export var MAGALU_SERVICE_CHECK_USER_CREDENTIALS = 'customer.checkCredentials';
export var MAGALU_SERVICE_CLOSE_MINIAPP = 'miniApp.onClose';
export var MAGALU_SERVICE_CUSTOMER_INFO = 'customer.getCustomerInfo';
export var MAGALU_SERVICE_REQUEST_USER_CREDENTIALS = 'customer.requestCredentials';